// Customizer const
export const TOGGLE_COLLAPSED_NAV = 'TOGGLE_COLLAPSE_MENU';
export const WINDOW_WIDTH = 'WINDOW-WIDTH';
export const SWITCH_LANGUAGE = 'SWITCH-LANGUAGE';

//Contact Module const
export const FETCH_START = 'fetch_start';
export const FETCH_SUCCESS = 'fetch_success';
export const FETCH_ERROR = 'fetch_error';
export const SHOW_MESSAGE = 'SHOW_MESSAGE';
export const HIDE_MESSAGE = 'HIDE_MESSAGE';
export const STORE_SUCCESS = 'STORE_SUCCESS'
export const ON_SHOW_LOADER = 'ON_SHOW_LOADER';
export const ON_HIDE_LOADER = 'ON_HIDE_LOADER';

//Auth const
export const SIGNUP_USER = 'SIGNUP_USER';
export const SIGNUP_USER_SUCCESS = 'SIGNUP_USER_SUCCESS';
export const SIGNIN_GOOGLE_USER = 'SIGNIN_GOOGLE_USER';
export const SIGNIN_GOOGLE_USER_SUCCESS = 'SIGNIN_GOOGLE_USER_SUCCESS';
export const SIGNIN_FACEBOOK_USER = 'SIGNIN_FACEBOOK_USER';
export const SIGNIN_FACEBOOK_USER_SUCCESS = 'SIGNIN_FACEBOOK_USER_SUCCESS';
export const SIGNIN_TWITTER_USER = 'SIGNIN_TWITTER_USER';
export const SIGNIN_TWITTER_USER_SUCCESS = 'SIGNIN_TWITTER_USER_SUCCESS';
export const SIGNIN_GITHUB_USER = 'SIGNIN_GITHUB_USER';
export const SIGNIN_GITHUB_USER_SUCCESS = 'signin_github_user_success';
export const SIGNIN_USER = 'SIGNIN_USER';
export const SIGNIN_USER_SUCCESS = 'SIGNIN_USER_SUCCESS';
export const SIGNOUT_USER = 'SIGNOUT_USER';
export const SIGNOUT_USER_SUCCESS = 'SIGNOUT_USER_SUCCESS';
export const INIT_URL = 'INIT_URL';
export const USER_DATA = 'user_data';
export const USER_TOKEN_SET = 'user_token_set';
export const USER_STORE_FIND = 'user_find_store';
export const USER_STORE_NOT_FOUND = 'user_store_not_found';
export const USER_LOGOUT = 'user_logout';
export const SHOW_SEKELETON_MENU = 'SHOW_SEKELETON_MENU';
export const HIDE_SEKELETON_MENU = 'HIDE_SEKELETON_MENU';
export const SET_SUBSCRIPTION = 'SET_SUBSCRIPTION';
export const LOAD_MENU = 'LOAD_MENU';
export const LOAD_DATA = 'LOAD_DATA';
//dashboard
export const USER_STATISTICS_DETAILS = 'user_statistics_details';
export const RETAIL_MEASURES_MODAL_SHOW = 'RETAIL_MEASURES_MODAL_SHOW';
export const RETAIL_METRICS_MEASURES_DATA = 'RETAIL_METRICS_MEASURES_DATA';
export const DASHBOARD_SEARCH_DATA = 'DASHBOARD_SEARCH_DATA';

//products data
export const PROMO_CODES = 'PROMO_CODES';
export const PROMO_CODES_MODAL = 'PROMO_CODES_MODAL';
export const PROMO_CODES_CREATED_NUMBER = 'PROMO_CODES_CREATED_NUMBER';
export const PRODUCT_BATCHES_ROW_DATA = 'PRODUCT_BATCHES_ROW_DATA';
export const FETCH_PRODUCTS_REQUEST = 'FETCH_PRODUCTS_REQUEST';
export const FETCH_PRODUCTS_SUCCESS = 'FETCH_PRODUCTS_SUCCESS';
export const FETCH_PRODUCTS_FAILURE = 'FETCH_PRODUCTS_FAILURE';
export const ON_SELECT_PRODUCT_DATA = 'ON_SELECT_PRODUCT_DATA';
export const GENERAL_IMPORT_PRODUCT_DATA = 'GENERAL_IMPORT_PRODUCT_DATA';

//sell
export const CASHMANAGE_ADD_MODAL_SHOW = 'CASHMANAGE_ADD_MODAL_SHOW';
export const CASHMANAGE_IS_REGISTOROPEN = 'CASHMANAGE_IS_REGISTOROPEN';
export const CASHMANAGE_IS_REGISTOR_LOADING = 'CASHMANAGE_IS_REGISTOR_LOADING';

export const OPENCLOSE_STORE_OUTLETS = 'OPENCLOSE_STORE_OUTLETS';
export const OPENCLOSE_SELECTED_STORE_OUTLETS = 'OPENCLOSE_SELECTED_STORE_OUTLETS';
export const OPENCLOSE_OUTLETS_REGISTERS = 'OPENCLOSE_OUTLETS_REGISTERS';
export const OPENCLOSE_SELECTED_OUTLETS_REGISTERS = 'OPENCLOSE_SELECTED_OUTLETS_REGISTERS';
export const OPENCLOSE_REGOUTLETS_LOADING = 'OPENCLOSE_REGOUTLETS_LOADING';
export const OPENCLOSE_CLOSEDREG_LOADING = 'OPENCLOSE_CLOSEDREG_LOADING';
export const OPENCLOSE_CASHLISTING_LOADING = 'OPENCLOSE_CASHLISTING_LOADING';
export const OPENCLOSE_CLOSEDREG_DATA = 'OPENCLOSE_CLOSEDREG_DATA';
export const OPENCLOSE_CASHLIST_DATALOAD = 'OPENCLOSE_CASHLIST_DATALOAD';
export const OPENCLOSE_LISTING_DATALOAD = 'OPENCLOSE_LISTING_DATALOAD';

//setup;
export const RECEIPT_TEMPLATES_DATA = 'RECEIPT_TEMPLATES_DATA';
export const RECEIPT_TEMPLATES_UPDATED = 'RECEIPT_TEMPLATES_UPDATED';
export const RECEIPT_TEMPLATES_LOADING = 'RECEIPT_TEMPLATES_LOADING';
export const USER_SUBS_INFO = 'USER_SUBS_INFO';

//SaleHistory
export const SALEHISTORY_CUSTOMER_SHOW = 'SALEHISTORY_CUSTOMER_SHOW';
export const SALEHISTORY_CUSTOMER_LOAD = 'SALEHISTORY_CUSTOMER_LOAD';
export const SEND_EMAIL_MODAL_SHOW = 'SEND_EMAIL_MODAL_SHOW';
export const STORE_USERS = 'STORE_USERS';

//Common Confgis
export const SET_COMMON_CONFIGS = 'SET_COMMON_CONFIGS';
export const IS_LOYALTY_ENABLED = 'IS_LOYALTY_ENABLED';
export const LOAD_CASH_OPEN_CLOSE_SUMMARY = 'LOAD_CASH_OPEN_CLOSE_SUMMARY'; // open/close pay summary data

//SellScreen
export const SELL_SCREEN_LOADING = 'SELL_SCREEN_LOADING';
export const SELL_PRODUCT_DETAIL = 'SELL_PRODUCT_DETAIL'; //prod stack
export const SELL_VARIANTS_PRODUCT = 'SELL_VARIANTS_PRODUCT'; //for variants
export const SELL_SELECTED_PRODUCTS = 'SELL_SELECTED_PRODUCTS'; //for sell cart list prod
export const SELL_SELECTED_SINGLE_PRODUCT = 'SELL_SELECTED_SINGLE_PRODUCT'; //for sell cart single prod
export const SALE_PRICEBOOKS = 'SALE_PRICEBOOKS'; //sell priceBooks Data
export const SALE_PROMOTIONS = 'SALE_PROMOTIONS'; //sell Promotions Data
export const SHOW_COMPLETE_SALE = 'SHOW_COMPLETE_SALE'; //sell Promotions Data
export const SALE_PRODUCT_JSON = 'SALE_PRODUCT_JSON'; //sell Product Data
export const SALE_PAYMENT_DATA = 'SALE_PAYMENT_DATA'; //sell Product Data

export const HISTORY_MODAL_CUS_SEARCH = 'HISTORY_MODAL_CUS_SEARCH';
export const VARIANT_MODAL_SHOW = 'VARIANT_MODAL_SHOW';
export const VARIANT_SELECTED_PROD_ID = 'VARIANT_SELECTED_PROD_ID';
export const CURRENT_SALES_ORDER_DATA = 'CURRENT_SALES_ORDER_DATA';
export const CURRENT_ORDER_GUID_ID = 'CURRENT_SALES_ORDER_ID';
export const CURRENT_SALES_ORDER_STATUS_DATA = 'CURRENT_SALES_ORDER_STATUS_DATA';
export const IS_DISCARD_SALE = 'IS_DISCARD_SALE';
export const REFUND_SALE_STATUS = 'REFUND_SALE_STATUS';
export const SALE_PROGRESS_MODAL_SHOW = 'SALE_PROGRESS_MODAL_SHOW';
export const TEMP_SALES_ORDER_DATA = 'TEMP_SALES_ORDER_DATA';

//PaymentsRelated
export const PAYMENT_STATUS_MODAL_SHOW = 'PAYMENT_STATUS_MODAL_SHOW';
export const PAYMENT_STATUS_WINDOW_CLOSE = 'PAYMENT_STATUS_WINDOW_CLOSE';
export const PAYMENT_TYPES_MODAL_SHOW = 'PAYMENT_TYPES_MODAL_SHOW';
export const PAYMENT_STATUS_DATA = 'PAYMENT_STATUS_DATA';
export const IS_SALE_PAYMENT_DONE = 'IS_SALE_PAYMENT_DONE';


//CustomersRelated
export const CUSTOMERS_ADDEDIT_MODAL_SHOW = 'CUSTOMERS_ADDEDIT_MODAL_SHOW';
export const CUSTOMERS_SEARCH_DATA = 'CUSTOMERS_SEARCH_DATA';
export const CUSTOMERS_SEARCH_DATA_FOR_HISTORY = 'CUSTOMERS_SEARCH_DATA_FOR_HISTORY';

//stock
export const STOCK_VIEW_DETAILS_DATA = 'STOCK_VIEW_DETAILS_DATA';
export const LOADER_LOGIN = 'LOADER_LOGIN';
export const STORE_INFO = 'STORE_INFO';
export const IS_DAY_PAST = 'IS_DAY_PAST';
export const IS_SELECT_REG = 'IS_SELECT_REG';

//Main Selling screen
export const SELL_PANEL_ACTIVE = 'SELL_PANEL_ACTIVE';
export const PAY_PANEL_LOADING = 'PAY_PANEL_LOADING';
export const IS_COMPLETE_PANEL_ACTIVE = 'IS_COMPLETE_PANEL_ACTIVE';
export const SALE_ORDER_DATA = 'SALE_ORDER_DATA';
export const CUS_OBJ = 'CUS_OBJ';
export const TAX_TABLE_DATA = 'TAX_TABLE_DATA';
export const DEFAULT_DEC_PLACES = 'DEFAULT_DEC_PLACES';
export const SALE_PAYMENTS = 'SALE_PAYMENTS';
export const PROD_TAB_DATA = 'PROD_TAB_DATA';
export const CUS_ACC_DETAIL = 'CUS_ACC_DETAIL';
export const ORDER_STATUSES = 'ORDER_STATUSES';
export const PAY_TYPES = 'PAY_TYPES';
export const IS_MAIN_LOADING = 'IS_MAIN_LOADING';
export const DATA_PRINT = 'DATA_PRINT';
export const PROMO_TABLE_DATA = 'PROMO_TABLE_DATA';
export const PAY_PROCESS_START = 'PAY_PROCESS_START';
export const IS_NOTE_VISIBLE = 'IS_NOTE_VISIBLE';
export const CURR_ORDER_STATUS = 'CURR_ORDER_STATUS';
export const IS_CREDIT_ENABLED = 'IS_CREDIT_ENABLED';
export const IS_SELL_LOYALTY_ENABLED = 'IS_SELL_LOYALTY_ENABLED';
export const LOYALTYAMOUNTVALUE = 'LOYALTYAMOUNTVALUE';
export const IS_DETAIL_LOADING = 'IS_DETAIL_LOADING';
export const PREVENT_RUNNER_EXEC = 'PREVENT_RUNNER_EXEC';
export const IS_REFUNDABLE = 'IS_REFUNDABLE';
export const IS_PARKED_VISIBLE = 'IS_PARKED_VISIBLE';
export const QUICK_KEYS_DETAILS = 'QUICK_KEYS_DETAILS';
export const IS_FOLDER_OPEN = 'IS_FOLDER_OPEN';
export const QUICK_KEY_COUNT = 'QUICK_KEY_COUNT';
export const MAIN_QUICK_KEY_DETAILS = 'MAIN_QUICK_KEY_DETAILS';
export const ALL_QUICK_KEY_DETAILS = 'ALL_QUICK_KEY_DETAILS';
export const ACTIVE_FOLDER_DATA = 'ACTIVE_FOLDER_DATA';
export const ACTIVE_COLOR_CODE = 'ACTIVE_COLOR_CODE';
export const IS_PROD_LOADING = 'IS_PROD_LOADING';
export const DISCOUNT_PRICE_TOTAL = 'DISCOUNT_PRICE_TOTAL';
export const SALES_STATUS_NAME = 'SALES_STATUS_NAME';
export const DISCOUNT_ROW_VISIBLE = 'DISCOUNT_ROW_VISIBLE';
export const PROMO_CODE_POPOVER_VISIBLE = 'PROMO_CODE_POPOVER_VISIBLE';
export const IS_TAX_POPOVER_VISIBLE = 'IS_TAX_POPOVER_VISIBLE';
export const IS_PROMO_POPOVER_VISIBLE = 'IS_PROMO_POPOVER_VISIBLE';
export const IS_DISCOUNT_POPOVER_VISIBLE = 'IS_DISCOUNT_POPOVER_VISIBLE';
export const IS_PAY_POPOVER_VISIBLE = 'IS_PAY_POPOVER_VISIBLE';
export const IS_TAX_EXCLUSIVE = 'IS_TAX_EXCLUSIVE';
export const DEFAULT_SALES_TAX_ID = 'DEFAULT_SALES_TAX_ID';
export const IS_BASIC_PERCENT = 'IS_BASIC_PERCENT';
export const FORM_DIS_CURR = 'FORM_DIS_CURR';
export const FORM_DIS_PER = 'FORM_DIS_PER';
export const FORM_SELL_NOTE = 'FORM_SELL_NOTE';
export const FORM_AMOUNT_TO_PAY = 'FORM_AMOUNT_TO_PAY';
export const FORM_LAYOUT_NAME = 'FORM_LAYOUT_NAME';
export const SELECTED_REG = 'SELECTED_REG';
export const SELECTED_OUTLET = 'SELECTED_OUTLET';
export const DEFAULT_LOYALTY_AMOUNT = 'DEFAULT_LOYALTY_AMOUNT';

export const REFUND_NEG_HANDLE = 'REFUND_NEG_HANDLE';
export const IS_EXCHANGE_SALE = 'IS_EXCHANGE_SALE';
export const IS_SHOW_RETURN_DIALOG = 'IS_SHOW_RETURN_DIALOG';
export const CHILD_DATA = 'CHILD_DATA';
export const IS_FILTER_SALE_CALL = 'IS_FILTER_SALE_CALL';
export const FILTER_SALE_ID = 'FILTER_SALE_ID';
export const REFUND_PROD_KEYS = 'REFUND_PROD_KEYS';
export const IS_ROW_DATA_UPDATED = 'IS_ROW_DATA_UPDATED';
export const PROMO_CODE_NOTIFY = 'PROMO_CODE_NOTIFY';
export const COMPLETE_SALE = 'COMPLETE_SALE';

export const STORE_USERS_CHANGE = 'STORE_USERS_CHANGE';

export const LOAD_ATTRIBUTE_DATA = 'LOAD_ATTRIBUTE_DATA';
export const DEFAULT_LABEL_PRINT_FORMAT = 'DEFAULT_LABEL_PRINT_FORMAT';
export const DEFAULT_SKU_GENERATION = 'DEFAULT_SKU_GENERATION';

//Reports
export const SPECIFIED_DATE_RANGE_JSON_DATA = 'SPECIFIED_DATE_RANGE_JSON_DATA';
export const COMPARISON_DATE_JSON_DATA = 'COMPARISON_DATE_JSON_DATA';
export const FORMAT_RESULT_JSON_DATA = 'FORMAT_RESULT_JSON_DATA';
export const EXPORT_REPORT_TYPE_DATA = 'EXPORT_REPORT_TYPE_DATA';
export const MEASURES_SELECTION_MODAL_SHOW = 'MEASURES_SELECTION_MODAL_SHOW';
export const CURR_PAGE_URL = 'CURR_PAGE_URL';
export const JSON_TO_EXCEL_DATA = 'JSON_TO_EXCEL_DATA';




//Reports
export const GET_INVENTORY_ITEMS_DATA = 'GET_INVENTORY_ITEMS_DATA';
export const GET_INVENTORY_ITEMS_LOADER = 'GET_INVENTORY_ITEMS_LOADER';
export const EARNED_LOYALTY = 'EARNED_LOYALTY';
export const SHOW_ISSUE_CREDIT_MODAL = 'SHOW_ISSUE_CREDIT_MODAL';
export const ACC_LAYBY_CREDITAMOUNT = 'ACC_LAYBY_CREDITAMOUNT';
export const SALE_REMAINING_AMOUNT = 'SALE_REMAINING_AMOUNT';
export const DELETED_PROD = 'DELETED_PROD';
export const PROMO_PROMPT = 'PROMO_PROMPT';
export const SHOW_PROMO_PROMPT = 'SHOW_PROMO_PROMPT';

export const IS_STORE_EXPIRED = 'IS_STORE_EXPIRED';
export const IS_OUTLET_INVENTORY_WARN = 'IS_OUTLET_INVENTORY_WARN';
export const LOAD_IS_IN_PROGRESS = 'LOAD_IS_IN_PROGRESS';
export const SUB_PERMISSIONS = 'SUB_PERMISSIONS';
export const IS_TRIAL = 'IS_TRIAL';
export const IS_ENTERPRISE = 'IS_ENTERPRISE';

export const CALCULATE_COMPARISON = 'CALCULATE_COMPARISON';
export const TOTAL_SAVING = 'TOTAL_SAVING';

export const SELLATTRIBUTESGROUPS = 'SELLATTRIBUTESGROUPS';
export const SELLATTRIBUTES = 'SELLATTRIBUTES';
export const ISSHOWSELLATTRIBUTE = 'ISSHOWSELLATTRIBUTE';
export const SELLATTRIBUTELOADING = 'SELLATTRIBUTELOADING';
export const SELLSELECTEDATTRIBUTES = 'SELLSELECTEDATTRIBUTES';

export const CONFIGSHOWSELLATTRIBUTE = 'CONFIGSHOWSELLATTRIBUTE';
export const CONFIGSHOWSELLLAYOUT = 'CONFIGSHOWSELLLAYOUT';
export const ENABLEAllPOSLAYOUTS = 'ENABLEAllPOSLAYOUTS';
export const PRODSVARIANTS = 'PRODSVARIANTS';
export const INVENTORYPOPUP = 'INVENTORYPOPUP';
export const SELLACTIONLOG = 'SELLACTIONLOG';

export const NotificationBar = 'NotificationBar';
export const NotificationHead = 'NotificationHead';

export const NotficationBGColor = 'NotficationBGColor';
export const ShowHeaderFooter = 'ShowHeaderFooter';
export const ShowContactUs = 'ShowContactUs';
export const ContactUsLoader = 'ContactUsLoader';

export const ShowNumpad = 'ShowNumpad';
export const ShowNumpadForDiscount = 'ShowNumpadForDiscount';
export const ShowNumpadForPayment = 'ShowNumpadForPayment';
export const NumPadType = 'NumPadType';
export const NumRelateData = 'NumRelateData';
export const NumDataChange = 'NumDataChange';

export const ShowAttribDrop = 'ShowAttribDrop';
export const DropDownStates = 'DropDownStates';

export const AttribGroups = 'AttribGroups';
export const ShowAttribSaleData = 'ShowAttribSaleData';

export const OPENCLOSEPRINTDATA = 'OPENCLOSEPRINTDATA';
export const SHOWPRINTOPENCLOSE = 'SHOWPRINTOPENCLOSE';

export const ISONLINE = 'ISONLINE';

//# Start Index DB Action Types Region 

export const ISINDEXDB = 'ISINDEXDB'

// End

export const ISALLPAID = 'ISALLPAID'
export const ISMOBAPP = 'ISMOBAPP'
export const GETAPPDATA = 'GETAPPDATA'
export const GETAPPNETWORK = 'GETAPPNETWORK'

export const MOUNTSELLATTRIBTABS = 'MOUNTSELLATTRIBTABS'
export const MOUNTSELLATTRIBTABS_TYPE = 'MOUNTSELLATTRIBTABS_TYPE'

export const SINGLE_SCREEN_FOR_CART = 'SINGLE_SCREEN_FOR_CART'
export const LOAD_SINGLE_PAY = 'LOAD_SINGLE_PAY'
export const SEND_PRINT = 'SEND_PRINT'

export const SHOW_QUICK_KEY = 'SHOW_QUICK_KEY'

export const CART_MAIN_CLASS = 'CART_MAIN_CLASS'
export const TRACK_BOX_COLOR = 'TRACK_BOX_COLOR'
export const TRACK_ROW_COLOR = 'TRACK_ROW_COLOR'

export const INV_ADJ_MOV = 'INV_ADJ_MOV'
export const ENABLE_TAX_CODE = 'ENABLE_TAX_CODE'

